import { AssignLifeExperienceComponent } from './../components/assign-life-experience/assign-life-experience.component';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AccommodationService {

  constructor(private http: HttpClient) { }


  countriesWithCities() {
    return this.http.get<ApiResponseModel>('/api/location/countriesWithCities');
  }

  getAllCountries() {
    return this.http.get<ApiResponseModel>('api/location/countries');
  }

  getAllCities(id: number) {
    return this.http.get<ApiResponseModel>('api/location/cities?countryId=' + id);
  }

  createAccommodation(data) {
    return this.http.post<ApiResponseModel>('api/accommodation', data);
  }

  getAccommodation(id) {
    return this.http.get<ApiResponseModel>('api/accommodation/' + id);
  }

  editAccommodation(body, id) {
    return this.http.put<ApiResponseModel>(
      'api/accommodation/' + id,
      body
    );
  }

  getAccommodations() {
    return this.http.get<ApiResponseModel>('api/accommodation');
  }

  getAccommodationsByCityId(cityId) {
    const params = new HttpParams()
      .set('cityId', cityId)
    return this.http.get<ApiResponseModel>('api/accommodation', { params });
  }

  assignLifeExperience(id, data) {
    return this.http.post<ApiResponseModel>('api/experience/' + id + '/assignLifeExperience', data);
  }


  getAllLocals() {
    return this.http.get<ApiResponseModel>('api/local/');
  }

  getAllExperience() {
    return this.http.get<ApiResponseModel>('api/experience');
  }

  getLocalsByCityId(cityId) {
    const params = new HttpParams()
      .set('cityId', cityId)
    return this.http.get<ApiResponseModel>('api/local/', { params });
  }
}
